export class SessionStatusResponse {
    Result: number;
    Response: boolean;
    Token: string;
}